import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import dayjs from "dayjs";
import {
  FaDownload,
  FaCheckDouble,
  FaThumbsDown,
  FaRedoAlt,
  FaCalendar,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import "./IndicatorCheckin.css";

function IndicatorCheckin({
  checkIn,
  type,
  minRange,
  maxRange,
  handleDownloadEvidence,
  handleShowValidation,
  handleShowReject,
  handleShowChangeDate,
  unValidateCheckIn,
  indicatorUserId,
  approverId,
  currentUserId,
  language,
  role,
}) {
  const { t } = useTranslation();

  const selectClassByLevel = (level, minRange, maxRange, type, completed) => {
    if (type === "completive") {
      if (completed) {
        return "checkIn-green";
      } else {
        return "checkIn-red";
      }
    } else if (type === "incremental") {
      if (level >= minRange && level <= maxRange) {
        return "checkIn-green";
      } else if (level < minRange) {
        return "checkIn-red";
      } else if (level > maxRange) {
        return "checkIn-blue";
      }
    } else if (type === "decremental") {
      if (level >= minRange && level <= maxRange) {
        return "checkIn-green";
      } else if (level < minRange) {
        return "checkIn-blue";
      } else if (level > maxRange) {
        return "checkIn-red";
      }
    }
  };

  return (
    <Col>
      <Row className="no-margin">
        <Col className="right mb-2 icons-menu">
          {role === "root" ? (
            <span
              className="icon-menu-item"
              onClick={() => handleShowChangeDate(checkIn._id)}
            >
              <FaCalendar />
            </span>
          ) : (
            <></>
          )}
          {checkIn.evidence !== "" &&
          (approverId === currentUserId ||
            indicatorUserId === currentUserId) ? (
            <span
              className="icon-menu-item"
              onClick={() => handleDownloadEvidence(checkIn.evidence)}
            >
              <FaDownload />
            </span>
          ) : (
            <></>
          )}
          {checkIn.acknowledgment === false &&
          approverId === currentUserId &&
          checkIn.rejection === false ? (
            <span
              className="icon-menu-item"
              onClick={() =>
                handleShowValidation(
                  checkIn._id,
                  checkIn.level,
                  checkIn.completed,
                  checkIn.created_at,
                )
              }
            >
              <FaCheckDouble />
            </span>
          ) : (
            <></>
          )}
          {checkIn.acknowledgment === true && role === "root" ? (
            <span
              className="icon-menu-item"
              onClick={() => unValidateCheckIn(checkIn._id)}
            >
              <FaRedoAlt />
            </span>
          ) : (
            <></>
          )}
          {checkIn.acknowledgment === false &&
          approverId === currentUserId &&
          checkIn.rejection === false ? (
            <span
              className="icon-menu-item"
              onClick={() => handleShowReject(checkIn._id)}
            >
              <FaThumbsDown />
            </span>
          ) : (
            <></>
          )}
        </Col>
      </Row>
      <Col className="last-checkin">
        {checkIn === undefined ? (
          <p className="no-checkins">{t("Indicadores.Detalles.NoCheckIns")}</p>
        ) : type === "completive" ? (
          <>
            {checkIn.rejection === false ? (
              <Row className="justify-content-center align-items-center mb-2">
                <Col lg={6}>
                  <p className="lastCheckinDate">
                    {dayjs(checkIn.created_at).format("D-MMM-YYYY")}
                  </p>
                </Col>
                <Col lg={6} className="right">
                  <span
                    className={selectClassByLevel(
                      checkIn.level,
                      minRange,
                      maxRange,
                      type,
                      checkIn.completed,
                    )}
                  >
                    Nivel: {checkIn.completed ? "Completado" : "No completado"}
                  </span>
                </Col>
              </Row>
            ) : (
              <Row className="justify-content-center align-items-center mb-2">
                <Col lg={4}>
                  <p className="lastCheckinDate">
                    {dayjs(checkIn.created_at).format("D-MMM-YYYY")}
                  </p>
                </Col>
                <Col lg={4}>
                  <span className="checkIn-rejected">
                    {t("Indicadores.Detalles.Rechazado")}
                  </span>
                </Col>
                <Col lg={4} className="right">
                  <span
                    className={selectClassByLevel(
                      checkIn.level,
                      minRange,
                      maxRange,
                      type,
                      checkIn.completed,
                    )}
                  >
                    Nivel: {checkIn.completed ? "Completado" : "No completado"}
                  </span>
                </Col>
              </Row>
            )}
            <Row>
              <Col>
                <Col>
                  <p className="lastCheckinNote">
                    <span className="strong">{t("Indicadores.User")}:</span>{" "}
                    {checkIn.note !== ""
                      ? checkIn.note
                      : t("Indicadores.Detalles.SinNota")}
                  </p>
                </Col>
                {checkIn.validationNote !== "" ? (
                  <Col className="mt-4">
                    <p className="lastCheckinNote">
                      <span className="strong">{t("Indicadores.Jefe")}:</span>{" "}
                      {checkIn.validationNote}
                    </p>
                  </Col>
                ) : (
                  <> </>
                )}
              </Col>
            </Row>
          </>
        ) : (
          <>
            {checkIn.rejection === false ? (
              <Row className="justify-content-center align-items-center mb-2">
                <Col lg={6}>
                  <p className="lastCheckinDate">
                    {dayjs(checkIn.created_at).format("D-MMM-YYYY")}
                  </p>
                </Col>
                <Col lg={6} className="right">
                  <span
                    className={selectClassByLevel(
                      checkIn.level,
                      minRange,
                      maxRange,
                      type,
                      checkIn.completed,
                    )}
                  >
                    {t("Indicadores.Nivel")}: {checkIn.level}
                  </span>
                </Col>
              </Row>
            ) : (
              <Row className="justify-content-center align-items-center mb-2">
                <Col lg={4}>
                  <p className="lastCheckinDate">
                    {dayjs(checkIn.created_at).format("D-MMM-YYYY")}
                  </p>
                </Col>
                <Col lg={4} className="center">
                  <span className="checkIn-rejected">
                    {t("Indicadores.Detalles.Rechazado")}
                  </span>
                </Col>
                <Col lg={4} className="right">
                  <span
                    className={selectClassByLevel(
                      checkIn.level,
                      minRange,
                      maxRange,
                      type,
                      checkIn.completed,
                    )}
                  >
                    {t("Indicadores.Nivel")}: {checkIn.level}
                  </span>
                </Col>
              </Row>
            )}

            <Row className="align-items-center">
              <Col>
                <Col lg={12}>
                  <p className="lastCheckinNote">
                    <span className="strong">{t("Indicadores.User")}:</span>{" "}
                    {checkIn.note !== ""
                      ? checkIn.note
                      : t("Indicadores.Detalles.SinNota")}
                  </p>
                </Col>
                {checkIn.validationNote !== "" ? (
                  <Col lg={12} className="mt-4">
                    <p className="lastCheckinNote">
                      <span className="strong">{t("Indicadores.Jefe")}:</span>{" "}
                      {checkIn.validationNote}
                    </p>
                  </Col>
                ) : (
                  <> </>
                )}
              </Col>
            </Row>
          </>
        )}
      </Col>
    </Col>
  );
}

export default IndicatorCheckin;
